import { reactive, ref } from 'vue';
import { useRoute } from 'vue-router';

import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign";
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import { CampaignListConfigBuilder } from '@/core/Campaign/config/CampaignConfigModel';
import BKCart from '@/module/ShoppingCart/service/BKCart';
import BKSubscription from '@/module/Subscription/List/service/BKSubscription';


export const useProductDetail = function () {
    const route = useRoute();
    const campaign = ref(null);
    const subscriptionItem = ref([]);
    const config = ref(new CampaignConfigBuilder())
    const events = reactive({
        onLoading: () => true,
        onLoaded: () => true,
        onSuccess: () => true,
        onError: () => true
    })

    // for edit mode
    const selectedOptions = reactive({
        meats: null,
        unlistIngredients: [],
        unlistMultiIngredients: [],
        unlistAppetizers: [],
        quantity: 1,
        sideCampaigns: [],
        remark: {
            others: [],
            addOns: [],
            appetizers: [],
            remarks: [],
        }
    })
    const isEditMode = ref(false)

    /**
     *
     * @param {string} keys
     * @returns {Promise<import("@/core/Cart/model/CartItemModel").CartItemModel>}
     */
    const getCartItem = function (keys) {
        return new Promise((resolve) => {
            BKCart.apiGetCartItem().subscribe({
                next: (data) => {
                    let item = data.find(x => x.rowKey == keys)
                    resolve(item)
                },
                error: () => {
                    resolve(null)
                }
            })
        })
    }

    const refreshBuilder = function () {
        campaign.value = null // for refresh page if click from shopping bag
        selectedOptions.meats = null
        selectedOptions.sideCampaigns = []
        selectedOptions.quantity = 1
        selectedOptions.unlistIngredients = []
        selectedOptions.unlistMultiIngredients = []
        selectedOptions.unlistAppetizers = []
        selectedOptions.remark = {
            others: [],
            addOns: [],
            appetizers: [],
            remarks: [],
        }
    }

    const getCampaignDetail = function () {
        config.value.setCampaignId(route.params.id);
        const _config = config.value.create();
        BzbsCampaign.apiGetCampaignDetail(_config)
            .subscribe({
                next: async (res) => {
                    await getSubscriptionItem();
                    events.onLoaded();
                    campaign.value = res;
                    events.onSuccess(res);
                },
                error: (err) => {
                    events.onLoaded();
                    events.onError(err);
                }
            });
    }

    const getSubscriptionItem = function () {
        return new Promise((resolve, reject) => {
            BKSubscription.apiGetSubscriptionItem(route.params.id)
                .subscribe({
                    next: (res) => {
                        subscriptionItem.value = res.data;
                     
                        resolve(res)
                    },
                    error: (err) => {
                        reject(err)
                    }
                });
        })
    }

    /**
     *
     * @param {string} keys
     */
    const init = function (keys = null) {
        events.onLoading()

        if (keys != null) {
            refreshBuilder()

            isEditMode.value = true
            // get cart item
            getCartItem(keys).then((cartItem) => {
                // console.log(cartItem)
                if (cartItem != null) {
                    selectedOptions.meats = cartItem.styleJson
                    selectedOptions.sideCampaigns = cartItem.sideCampaigns
                    selectedOptions.quantity = cartItem.quantity
                    selectedOptions.unlistIngredients = cartItem.remark.remarks
                    selectedOptions.unlistMultiIngredients = cartItem.remark.remarks
                    selectedOptions.unlistAppetizers = cartItem.remark.appetizers
                    selectedOptions.remark.others = cartItem.remark.others
                    selectedOptions.remark.addOns = cartItem.remark.addons
                    selectedOptions.remark.appetizers = cartItem.remark.appetizers
                    selectedOptions.remark.remarks = cartItem.remark.remarks
                }
                getCampaignDetail()
            })
        } else {
            getCampaignDetail()
        }
    }

    return {
        campaign,
        subscriptionItem,
        init,
        events,
        selectedOptions,
        isEditMode,
    }
}

export const UrlCommandService = {
    SetFav: 'set-fav-true'
}

export const urlCommandService = function(cmd){
    if(cmd == UrlCommandService.SetFav){
        // call service fav
    }
}

export const getCampaignsByConfig = function (config) {
    return new Promise((resolve, reject) => {
        let builder = new CampaignListConfigBuilder()
        builder.setConfigList(config)
        builder.setTop(100)

        BzbsCampaign.apiGetCampaign(builder.create())
            .subscribe({
                next: (res) => {
                    resolve(res)
                },
                error: (err) => {
                    reject(err)
                }
            });
    })
}

export default useProductDetail
